// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"14bf7c8b","977":"048b3b84"}[chunkId] + ".chunk.js";
};